import r, { OPTIONS as z } from "../managers/braze-instance.js";
import ro from "../util/browser-detector.js";
import lr from "./l10n-manager.js";
var fe = {
  i: !1,
  aa: null,
  ea: function ea() {
    if (fe.t(), !fe.aa) {
      var e = ro.language,
        t = !1;
      r.ee(z.Xn) && (e = r.ee(z.Xn), t = !0), fe.aa = new lr(e, t);
    }
    return fe.aa;
  },
  t: function t() {
    fe.i || (r.g(fe), fe.i = !0);
  },
  destroy: function destroy() {
    fe.aa = null, fe.i = !1;
  }
};
export default fe;